import { FC } from 'react';

import { useMediaQuery } from '~/common/hooks/use-media-query';
import { Typography } from '~/common/components/Typography';
import { Modal } from '~/common/components/Modal';

import { StyContainer, StyContent } from './styles';

interface IAboutUsModal {
  open: boolean;
  close: () => void;
}
export const AboutUsModal: FC<IAboutUsModal> = ({ open, close }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Modal
      title="Sobre nós"
      isOpen={open}
      onClose={close}
      id="about-us-modal"
      height={isMobile ? '100%' : 'auto'}
      width="500px"
    >
      <StyContainer>
        <StyContent>
          <Typography.Label size="medium">Quem somos</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            A CryptoControl Labs é uma empresa de tecnologia focada em controle,
            acompanhamento e inteligência de portfólio. Desenvolvemos uma
            plataforma SaaS que ajuda investidores a organizarem seus ativos,
            acompanharem desempenho e tomarem decisões com mais clareza, usando
            tecnologia como suporte estratégico.
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">Nossa Missão</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Oferecer ferramentas que tragam visão real, organização e controle
            sobre investimentos, reduzindo ruído, improviso e dependência de
            soluções complexas ou mal adaptadas à realidade do investidor
            brasileiro.
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">Nossa Visão</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Ser uma das principais plataformas de controle e inteligência de
            portfólio da América Latina, reconhecida pela confiabilidade,
            clareza e profundidade das análises entregues aos usuários.
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">Nossos Valores</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Acessibilidade: ferramentas claras e utilizáveis por diferentes
            perfis de investidores Praticidade: foco no que realmente importa
            para a tomada de decisão Transparência: informações objetivas e
            comunicação direta Inovação: uso contínuo de tecnologia para gerar
            mais contexto e eficiência Resultado: foco em clareza, controle e
            evolução do investidor ao longo do tempo
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">O Que Oferecemos</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            A plataforma CryptoControl oferece:
            <br />
            – Curso introdutório de uso da ferramenta
            <br />
            – Gestão e acompanhamento de portfólio
            <br />
            – Indicadores e métricas de desempenho
            <br />
            – Alertas e monitoramento de mercado
            <br />
            – Monitoramento de redes sociais
            <br />– Recursos de inteligência artificial aplicados ao contexto do
            investidor
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">Nossa História</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            A CryptoControl nasceu de uma dor real.
            <br />
            Em 2020, quem se interessava por tecnologia e investimentos
            encontrava basicamente duas opções: ferramentas estrangeiras, caras
            e pouco adaptadas à realidade brasileira, ou soluções genéricas que
            não resolviam o problema central, que era ter controle e clareza
            sobre o próprio portfólio.
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">Nossos Valores</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Acessibilidade: ferramentas claras e utilizáveis por diferentes
            perfis de investidores Praticidade: foco no que realmente importa
            para a tomada de decisão Transparência: informações objetivas e
            comunicação direta Inovação: uso contínuo de tecnologia para gerar
            mais contexto e eficiência Resultado: foco em clareza, controle e
            evolução do investidor ao longo do tempo
            <br />
            Diante disso, dois entusiastas de tecnologia e investimentos
            decidiram criar a própria solução, unindo experiência prática em
            criptoativos com tecnologia de ponta. Desde o início, a visão foi
            clara: não criar uma plataforma educacional tradicional, mas sim uma
            ferramenta de controle, acompanhamento e inteligência de portfólio.
            <br />
            Com a bagagem do Augusto Backes no mercado cripto e uma base
            tecnológica sólida, surgiu a CryptoControl, uma plataforma pensada
            para quem já investe e precisa organizar, monitorar, analisar e
            tomar decisões com mais clareza, independentemente do cenário de
            mercado.
          </Typography.Label>
        </StyContent>

        <StyContent>
          <Typography.Label size="medium">
            Tecnologia e Segurança
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            A CryptoControl foi construída com foco em estabilidade, segurança e
            performance, utilizando tecnologias modernas de cloud computing para
            garantir alta disponibilidade, segurança de dados com criptografia
            ponta a ponta, experiência responsiva em web e mobile, performance
            rápida mesmo com grandes volumes de dados e backups automáticos
            diários para garantir a integridade das informações.
            <br />
            Mais do que gráficos ou visualizações, a CryptoControl entrega
            controle, contexto e confiança para quem leva investimentos a sério.
          </Typography.Label>
        </StyContent>
      </StyContainer>
    </Modal>
  );
};
